import { getRequest, postRequest } from "../../config/AxiosConfig";
import API_URLS from "../../config/BackendConfig";
import { getAuthToken } from "../../utils/tokenUtils";

//  Signup Report Service
export const SignUpReportService = async (
  page = 1,
  filters = {
    total_data: 10, // Possible values: 10, 20, 50, 100
    from_date: "",
    to_date: "",
    status: "", // PENDING, APPROVED, REJECTED, HOLD, REKYC
    api_id: "",
    mobile: "",
    email: "",
  },
) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}website-user/report?page=${page}`,
      headers: { Authorization: `Bearer ${token}` },
      data: filters,
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to fetch signup report",
    };
  }
};

// update User Status
export const UpdateUserStatus = async ({
  user_id,
  status,
  comment,
  referred_by,
}) => {
  try {
    const payload = {
      user_id: user_id,
      status: status, //PENDING,APPROVED,REJECTED,HOLD,REKYC
      comment: comment,
    };

    if (referred_by) payload.referred_by = referred_by;
    
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}website-user/status`,
      headers: { Authorization: `Bearer ${token}` },
      data: payload,
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to update status",
    };
  }
};

// update Doct Status
export const UpdateDoctStatus = async ({
  user_id,
  document_id,
  status,
  comment,
}) => {
  try {
    const payload = {
      user_id: user_id,
      document_id: document_id,
      status: status, // APPROVED,REJECTED
      comment: comment,
    };
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}website-user/document-status`,
      headers: { Authorization: `Bearer ${token}` },
      data: payload,
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to update status",
    };
  }
};

// get All 8 Doct
export const GetUserDocuments = async (user_id) => {
  try {
    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}website-user/document`,
      headers: { Authorization: `Bearer ${token}` },
      data: { user_id },
    });

    return response;
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message || "Failed to retrieve user documents",
    };
  }
};

// ✅ Get Digital KYC Response Status for a Specific Field
// field can be : 'aadhar', 'pan', 'mobile', 'email'

export const UserDigitalKycStatus = async ({ user_id, field, remarks }) => {
  try {
    const payload = {
      user_id,
      remarks,
    };

    const token = getAuthToken();
    const response = await postRequest({
      // ✅ corrected URL
      url: `${API_URLS.ADMIN}user/digital-kyc-status/${field}`,
      headers: { Authorization: `Bearer ${token}` },
      data: payload,
    });

    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to update status",
    };
  }
};

// user KYC physical status user/kyc-status
export const UserKycStatus = async ({ user_id, status_id, remarks }) => {
  try {
    const payload = {
      user_id,
      status_id, // approve,reject
      remarks,
    };

    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}user/kyc-status`,
      headers: { Authorization: `Bearer ${token}` },
      data: payload,
    });

    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to update status",
    };
  }
};

export const UserCounts = async ({ status }) => {
  try {
    const payload = {
      status, // PENDING,APPROVED,REJECTED,HOLD,REKYC
    };

    const token = getAuthToken();
    const response = await postRequest({
      url: `${API_URLS.ADMIN}website-user/count`,
      headers: { Authorization: `Bearer ${token}` },
      data: payload,
    });

    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to update status",
    };
  }
};

export const getWebLeadCount = async () => {
  try {
    const token = getAuthToken();
    const response = await getRequest({
      url: `${API_URLS.ADMIN}enquiry/count`,
      headers: { Authorization: `Bearer ${token}` },
    });

    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to update status",
    };
  }
};
